// Phase HUB-DRILL-1 — Campus Hubs list (likely empty).
import { useNavigate } from "react-router-dom";
import { ArrowLeft, RefreshCw, Building2 } from "lucide-react";
import RoleGate from "../../components/RoleGate";
import useTimedFetch from "../../hooks/useTimedFetch";
import { HubDetailError } from "../../components/founder/MainHubDetailView";

function Body() {
  const nav = useNavigate();
  const { data, loading, error, reload } = useTimedFetch("/founder/campus-hubs");
  const rows = data?.rows || [];
  return (
    <div className="max-w-7xl mx-auto p-4 sm:p-6" data-testid="founder-campus-hubs-list">
      <div className="flex items-center gap-2 mb-4">
        <button onClick={() => nav("/dashboard/ceo")}
                className="text-[#FF6B00] hover:opacity-80" data-testid="campus-hubs-back">
          <ArrowLeft className="h-5 w-5"/>
        </button>
        <h1 className="text-2xl font-bold text-slate-900">Campus Hubs</h1>
        <span className="text-sm text-slate-500">· {rows.length}</span>
        <button onClick={reload} className="ml-auto text-slate-400 hover:text-[#FF6B00]"
                aria-label="Refresh" data-testid="campus-hubs-refresh">
          <RefreshCw className="h-4 w-4"/>
        </button>
      </div>
      {error && <HubDetailError {...error} onRetry={reload}/>}
      {loading && !data && (
        <div className="h-24 bg-slate-100 rounded-2xl animate-pulse" data-testid="campus-hubs-loading"/>
      )}
      {data && rows.length === 0 && (
        <div className="bg-white border border-slate-200 rounded-2xl py-12 px-4 text-center"
             data-testid="campus-hubs-empty">
          <Building2 className="h-10 w-10 text-slate-300 mx-auto mb-2"/>
          <div className="text-slate-700 font-semibold">No campus hubs yet</div>
          <div className="text-xs text-slate-500 mt-1">Campus hubs are coming soon — designed for university and corporate campus deliveries.</div>
        </div>
      )}
      {rows.length > 0 && (
        <div className="bg-white border border-slate-200 rounded-2xl overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50/70">
              <tr className="text-left text-slate-500">
                <th className="px-3 py-2 text-[10px] uppercase tracking-wider">Name</th>
                <th className="px-3 py-2 text-[10px] uppercase tracking-wider">ID</th>
                <th className="px-3 py-2 text-[10px] uppercase tracking-wider">City</th>
                <th className="px-3 py-2 text-[10px] uppercase tracking-wider">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {rows.map((r) => (
                <tr key={r.hub_id}>
                  <td className="px-3 py-2 font-semibold">{r.name}</td>
                  <td className="px-3 py-2 font-mono text-xs">{r.hub_id}</td>
                  <td className="px-3 py-2">{r.city || "—"}</td>
                  <td className="px-3 py-2">{r.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default function CampusHubsList() {
  return <RoleGate allow={["founder", "admin", "main_hub_manager", "ceo"]}><Body/></RoleGate>;
}
